import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=46e34d2a&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=js"
export * from "./MainNavigation.vue?vue&type=script&lang=js"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=46e34d2a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e34d2a",
  null
  
)

export default component.exports